'use client';

import { c as _c } from "react/compiler-runtime";
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { ServiceLogisticItem, type ServiceLogisticItemProps } from '@/app/cv/components/sections/service/service-logistic/item';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface ServiceLogisticProps {
  title?: string;
  items?: ServiceLogisticItemProps[];
}
export const ServiceLogistic = t0 => {
  const $ = _c(11);
  const {
    items: t1,
    title
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      defaultBaseDelay: 0.04
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useRevealAnim(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "service-logistic-section"
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = !!title && <h2 data-revealanim={true} data-order="1" className="text-h2 font-display text-center" dangerouslySetInnerHTML={{
      __html: title
    }} {...createDataAttributes({
      test: "heading"
    })} />;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== items) {
    t6 = items.map(_temp);
    $[6] = items;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Section size="lg" className="bg-silver-50" {...t4} data-revealanim-group={true}><Container>{t5}{t6}</Container></Section>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
function _temp(item, index) {
  return <ServiceLogisticItem key={index} index={index} {...item} />;
}